import { Modal, Grid, Text, Heading } from '@simplywallst/ui-core';

import { StyledUl, StyledLi } from './styled';

export const InformationModal = ({ onClose }: { onClose: () => void }) => {
  return (
    <Modal
      title="Portfolio Snowflake"
      onSecondaryClick={onClose}
      secondaryLabel="Close"
    >
      <Grid gap="16px">
        <Text color="inherit" typography="xSmall">
          The Portfolio Snowflake provides a comprehensive overview of your
          entire investment portfolio, offering a consolidated snapshot of the
          combined fundamental health of the companies within it. It is a visual
          representation derived from aggregating the individual Snowflakes of
          the companies in your portfolio.
        </Text>
        <Heading as="h3" color="inherit" typography="smallStrong">
          Key Features:
        </Heading>
        <StyledUl>
          <StyledLi>
            <Text color="inherit" typography="xSmall">
              <strong>Colour and Size:</strong> Like individual Snowflakes, the
              Portfolio Snowflake displays a colour and size that reflect the
              overall health and attractiveness of your portfolio. A larger and
              greener Snowflake suggests a portfolio with strong fundamentals
              across the aggregated companies, while a smaller and more red
              Snowflake indicates areas where your portfolio may need attention.
            </Text>
          </StyledLi>
          <StyledLi>
            <Text color="inherit" typography="xSmall">
              <strong>Aggregate Assessment:</strong> The Portfolio Snowflake
              summarises the collective performance of your investments across
              key fundamental areas, such as Value, Future, Past, Health, and
              Dividend. It combines the metrics from all the companies in your
              portfolio to give you a consolidated view and it helps you
              understand the overall strengths and weaknesses of your portfolio,
              making it easier to determine whether further research or
              rebalancing is necessary.
            </Text>
          </StyledLi>
          <StyledLi>
            <Text color="inherit" typography="xSmall">
              <strong>Informed Decision-Making:</strong> Understanding the
              aggregate health of your portfolio is crucial for making
              well-informed investment decisions and for ensuring that your
              investments align with your financial goals and risk tolerance.
            </Text>
          </StyledLi>
        </StyledUl>
      </Grid>
    </Modal>
  );
};
